import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthForm } from '../../components/Forms'
import { FormProvider } from '../../context/FormContext'
import { AuthConsumer } from '../../context/AuthContext'

export default class AuthPage extends Component {

  render() {
    return (
      <FormProvider>
        <AuthConsumer>
          {({ fetching, accessKey, loggedIn, error, requestSession, requestSessionRegister, resetErrors }) => {
            if (!fetching && !error && accessKey.length === 0 && !loggedIn) {
              // Debouncing for stability
              setTimeout(() => {
                requestSession()
              }, 2000)
            }
            return (
              <>
                <Route path="/login" exact render={(props) => <AuthForm {...props} loading={fetching} error={error} onLogin={requestSessionRegister} resetErrorsDispatch={resetErrors} />} />

                {
                  // If we are logged in, we should not be here, so we go to home :P
                  loggedIn ? <Redirect to="/" /> : null
                }
              </>
            )
          }}
        </AuthConsumer>
      </FormProvider>
    )
  }
}
